<template>
  <div style="margin:10px 5px 0;width: 100%;">
    <el-row type="flex"
            justify="space-between"
            :gutter="20">
      <el-col :span="12">
        <el-radio-group v-model="approveGroupIndex"
                        size="mini"
                        class="radio-group"
                        @change="changeApproveGroupIndex">
          <el-radio-button label="0">全部逾期</el-radio-button>
          <el-radio-button label="1">进度逾期</el-radio-button>
          <el-radio-button label="2">操作超期</el-radio-button>
        </el-radio-group>
      </el-col>
      <el-col :span="4">
        <el-radio-group v-model="isMyApply"
                        size="mini"
                        class="radio-group"
                        style="float:right"
                        @change="refershSource">
          <el-radio-button label="false">我申请</el-radio-button>
          <el-radio-button label="true">我审批</el-radio-button>
        </el-radio-group>
      </el-col>
      <el-col :span="4">
        <el-radio-group v-model="isApprove"
                        size="mini"
                        class="radio-group"
                        style="float:right"
                        @change="refershSource">
          <el-radio-button label="false">未审核</el-radio-button>
          <el-radio-button label="true">已审核</el-radio-button>
        </el-radio-group>
      </el-col>
    </el-row>

    <div v-loading="loading">
      <el-scrollbar :style="scrollHeight">
        <DelayInfoCard @refershSource="refershSource"
                       v-for="item in approveTaskTable"
                       :key="item.ID"
                       :curDelayInfo="item"></DelayInfoCard>
      </el-scrollbar>
      <p v-cloak
         v-show="approveTaskCountZero">当前无数据</p>
    </div>
  </div>
</template>

<script>
import { getToken } from "./../../../util/auth";
import DelayInfoCard from "./DelayInfoCard.vue";
import { GetMyApproveTaskDelay } from "@/api/modules/basicData/task";
const cookieUser = getToken();
export default {
  components: {
    DelayInfoCard
  },
  data() {
    return {
      approveGroupIndex: "0",
      allApproveTaskTable: [],
      approveTaskTable: [],
      loading: false,
      isApprove: false,
      isMyApply: false,
      scrollHeight: ""
    };
  },
  computed: {
    approveTaskCountZero() {
      console.log("this.approveTaskTable.length", this.approveTaskTable.length);
      return this.approveTaskTable.length == 0;
    }
  },
  mounted() {
    this.refershSource();
  },
  methods: {
    //逾期审批类型切换
    changeApproveGroupIndex(index) {
      switch (index) {
        case "0":
          this.approveTaskTable = this.allApproveTaskTable;
          break;
        case "1":
          this.approveTaskTable = this.allApproveTaskTable.filter(
            o => o.DELAYTYPE === 0
          );
          break;
        case "2":
          this.approveTaskTable = this.allApproveTaskTable.filter(
            o => o.DELAYTYPE === 1
          );
          break;
      }
    },
    created() {
      let a = $(window).height();
      this.scrollHeight = "height:" + (a - 180) + "px;";
    },
    //刷新数据源
    refershSource() {
      console.log("refershSource");
      this.approveTaskTable = [];
      this.loading = true;
      console.log("isApprove " + this.isApprove);
      console.log("isMyApply " + this.isMyApply);
      GetMyApproveTaskDelay(cookieUser.userId, this.isApprove, this.isMyApply)
        .then(data => {
          console.log("allApproveTaskTable ", data);
          this.allApproveTaskTable = data;
          this.changeApproveGroupIndex(this.approveGroupIndex);
          this.loading = false;
        })
        .catch(() => (this.loading = false));
    }
  }
};
</script>

<style scoped>
[v-cloak] {
  display: none;
}
.radio-group {
  margin-bottom: 10px;
}
</style>